import { useLocation } from '@reach/router';
import { isHttpsUri, isWebUri } from 'valid-url';
import { navigate } from 'gatsby';

export const isPvolveDomain = (url: string) => {
    return !!isWebUri(url) && !!new URL(url).hostname.match(/pvolve.com$/);
};

export const isMuxDomain = (url: string) => {
    return !!isHttpsUri(url) && !!new URL(url).hostname.match(/(image|stream)\.mux\.com$/);
};

// This method exists in case we add other criteria for mux urls in the future
export const isValidMuxUrl = (url: string) => {
    return isMuxDomain(url);
};

export const isPathOnly = (url: string) => {
    return !url.match(/^\\w+:\/\//);
};

// This method exists in case we add other criteria to redirect urls in the future
export const isValidRedirectUrl = (redirectUrl: string) => {
    return (
        redirectUrl &&
        (isPathOnly(redirectUrl) ||
            isPvolveDomain(redirectUrl) ||
            new URL(redirectUrl).hostname === 'localhost')
    );
};

export const redirect = (url: string) => {
    if (window && isValidRedirectUrl(url)) {
        window.location.replace(url);
    } else {
        navigate('/');
    }
};

// This custom hook is used to store the current location in sessionStorage
export const useSaveUrl = (keyName: string): (() => void) => {
    const location = useLocation();

    const saveInSessionStorage = () => {
        window?.sessionStorage?.setItem(keyName, location?.pathname || '');
    };

    return saveInSessionStorage;
};
